import { Menu } from "./menu.es.js";
import { MenuItem } from "./menu-item.es.js";
Menu.Item = MenuItem;
export {
  Menu,
  MenuItem
};
